import React from "react";

export const formatWritingText = (text) => {
  if (!text) return null;
  return text.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line.split("\\n").map((sent, i) => (
        <p style={{ margin: "0px" }} key={i}>
          {" "}
          {sent}
        </p>
      ))}
      <br />
    </React.Fragment>
  ));
};

export const countWords = (text) => {
  if (!text) return 0;
  return text
    .trim()
    .split(/\s+/)
    .filter((word) => word).length;
};

export const clearClipboard = () => {
  navigator.clipboard.writeText("").catch((error) => {
    console.error("Clipboard clear error:", error);
  });
};

export const getSelectedText = (textArea) => {
  const selectionStart = textArea.selectionStart;
  const selectionEnd = textArea.selectionEnd;
  
  if (selectionStart !== selectionEnd) {
    return {
      text: textArea.value.substring(selectionStart, selectionEnd),
      start: selectionStart,
      end: selectionEnd
    };
  }
  return null;
};

export const insertTextAtCursor = (textArea, text, currentValue, setValue) => {
  const selectionStart = textArea.selectionStart;
  const selectionEnd = textArea.selectionEnd;
  const newValue = currentValue.slice(0, selectionStart) + text + currentValue.slice(selectionEnd);
  setValue(newValue);
  
  const newCursorPosition = selectionStart + text.length;
  setTimeout(() => {
    textArea.setSelectionRange(newCursorPosition, newCursorPosition);
  }, 0);
};

export const removeSelectedText = (textArea, currentValue, setValue) => {
  const selectionStart = textArea.selectionStart;
  const selectionEnd = textArea.selectionEnd;
  
  if (selectionStart !== selectionEnd) {
    const newValue = currentValue.slice(0, selectionStart) + currentValue.slice(selectionEnd);
    setValue(newValue);
    
    setTimeout(() => {
      textArea.setSelectionRange(selectionStart, selectionStart);
    }, 0);
  }
};
